import { render, staticRenderFns } from "./SafeView.vue?vue&type=template&id=178a86bd&scoped=true&"
import script from "./SafeView.vue?vue&type=script&lang=js&"
export * from "./SafeView.vue?vue&type=script&lang=js&"
import style0 from "./SafeView.vue?vue&type=style&index=0&id=178a86bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178a86bd",
  null
  
)

export default component.exports